import { Box, Grid, Stack, useTheme } from '@mui/material';

import { EditableRegion } from '@/components/blockEditor/EditableRegion/EditableRegion';
import { LegendItem } from '@/components/charts/Legend/Legend';
import { Divider } from '@/components/Divider';
import { Card } from '@/components/layout/Card/Card';

import { EducationalSlideH4 } from '../../components/EducationalSlide.components';
import { SVGVariableContainer } from '../../components/SVGVariableContainer';
import UnitedStates from './UnitedStates.svg?react';

export function StateInheritanceTaxExplainer() {
  const theme = useTheme();
  const primaryColor = theme.palette.dataVisualizationPrimary.main;
  const secondaryColor = theme.palette.dataVisualizationSecondary.main;
  const negativeColor = theme.palette.dataVisualizationNegative.main;

  return (
    <Stack spacing={4}>
      <Stack direction="row" spacing={2}>
        <Card variant="outlined" sx={{ p: 2, width: '70%' }}>
          <Stack spacing={2} divider={<Divider />}>
            <Box>
              <SVGVariableContainer
                sx={{ alignItems: 'center', width: '75%', margin: '0 auto' }}
              >
                <UnitedStates />
              </SVGVariableContainer>
            </Box>
            <Box>
              <Stack spacing={2}>
                <Box textAlign="center">
                  <EducationalSlideH4 sx={{ mb: 2 }}>
                    States with an estate tax
                  </EducationalSlideH4>
                  <Grid container spacing={1} justifyContent="center" mt={1}>
                    {[
                      'Connecticut',
                      'District of Columbia',
                      'Hawaii',
                      'Illinois',
                      'Maine',
                      'Massachusetts',
                      'Minnesota',
                      'New York',
                      'Oregon',
                      'Rhode Island',
                      'Vermont',
                      'Washington',
                    ].map((state) => (
                      <Grid key={state} item sx={{ width: '25%' }}>
                        <LegendItem
                          primaryText={state}
                          legendItemColor={primaryColor}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Box>

                <Box textAlign="center">
                  <EducationalSlideH4 sx={{ mb: 2 }}>
                    States with an inheritance tax
                  </EducationalSlideH4>
                  <Grid container spacing={1} justifyContent="center" mt={1}>
                    {['Kentucky', 'Nebraska', 'New Jersey', 'Pennsylvania'].map(
                      (state) => (
                        <Grid key={state} item sx={{ width: '25%' }}>
                          <LegendItem
                            primaryText={state}
                            legendItemColor={secondaryColor}
                          />
                        </Grid>
                      )
                    )}
                  </Grid>
                </Box>

                <Box textAlign="center">
                  <EducationalSlideH4 sx={{ mb: 2 }}>
                    State with both estate & inheritance taxes
                  </EducationalSlideH4>
                  <Grid container spacing={1} justifyContent="center" mt={1}>
                    <Grid
                      item
                      sx={{
                        width: '100%',
                      }}
                    >
                      <LegendItem
                        primaryText="Maryland"
                        legendItemColor={negativeColor}
                        containerSx={{
                          alignItems: 'center',
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Stack>
            </Box>
          </Stack>
        </Card>

        <Card variant="filled" sx={{ p: 2, width: '30%' }}>
          <EditableRegion regionId="state-tax-list" />
        </Card>
      </Stack>
    </Stack>
  );
}
